import type { Antenna } from '../types';

export interface ContactGroup<T> {
  key: string;
  missionId: string;
  site: string;
  contacts: T[];
}

/** Match the station naming used by the antenna browser. Unnamed antennas stay separate. */
export function groupContactsBySite<T extends { missionId: string; antennaId: string }>(
  contacts: readonly T[],
  antennas: readonly Antenna[],
): ContactGroup<T>[] {
  const byId = new Map(antennas.map((a) => [a.id, a]));
  const groups = new Map<string, ContactGroup<T>>();
  for (const c of contacts) {
    const a = byId.get(c.antennaId);
    const site = a?.location.name?.trim() || a?.shortName || c.antennaId;
    const siteKey = a?.location.name?.trim()
      ? `${a.location.country?.trim().toLowerCase() ?? ''}|${site.toLowerCase()}`
      : c.antennaId;
    const key = `${c.missionId}|${siteKey}`;
    if (!groups.has(key)) groups.set(key, { key, missionId: c.missionId, site, contacts: [] });
    // Keep a unique antenna reading even if an earlier client retained a duplicate AOS.
    if (!groups.get(key)!.contacts.some((item) => item.antennaId === c.antennaId))
      groups.get(key)!.contacts.push(c);
  }
  return [...groups.values()];
}
